import { getAllReceipt, getClass, getDiscounts, getPayments, getStudent } from "api/api";
import Loading from "components/Loading";
import { PaymentModalComponent, PromotionModalComponent, ReceiptModalComponent } from "components/ModalComponent";
import { NoDataWithImageText } from "components/NoDataComponent";
import { OutlinePrimaryBtn, SolidPrimaryBtn, SolidPrimarySubBtn } from "components/button/Button";
import Pagenation from "components/common/Pagenation";
import { SelectOption } from "components/input/Input";
import {
  CustomDatePickerWrap,
  ListContentWrap,
  PageArticleWrap,
  PageHeaderTitleButtonStyle,
  TwoListContentWrap,
} from "components/layout/Layout";
import { getMonth, getYear, subYears } from "date-fns";
import { createContext, useCallback, useContext, useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import { Outlet, useLocation } from "react-router-dom";
import styled from "styled-components";
import { RoundIcon, TooltipIcon } from "components/common/Icon";
import {
  ClassInfo,
  DiscountInfo,
  PaymentInfo,
  ReceiptInfo,
  ReceiptTotalInfo,
  StudentInfo,
  provinceInfo,
} from "type/type";
import {
  MONTHS,
  PayStatusType,
  PaymentDetailType,
  aesCBCDecrypt,
  changeReceiptPaymentType,
  checkPromiseOfServer,
  formatCurrency,
  formattedSelectOption,
  getCurrentDateTime,
  getDayClassName,
} from "utils/commonUtils";
import { ReactComponent as AlphabetX } from "assets/image/common/X.svg";
import { ReactComponent as AlphabetO } from "assets/image/common/O.svg";
import {SITEID, useLoginUserInfo} from "../../redux/hook/useLoginUserInfo";
import { holidayState } from "styles/atoms";
import { useRecoilValue } from "recoil";


const Article = styled.article`
  min-height: 18.75rem;
  height: 100%;
  background-color: ${({theme}) => theme.rootWhite};
  border-radius: 0.5rem;
  padding: 1.25rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  .article-header {
    height: 1.25rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    color: ${({theme}) => theme.newTheme.table.tableHeadText};
    p:first-of-type {
      display: flex;
      flex-direction: row;
      gap: 0.5rem;
    }
    .article-header-title {
      color: ${({theme}) => theme.newTheme.text.mainText};
      font-size: 1rem;
    }
  }
  .join-wrap {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    // height: 100%;
    height: calc(100% - 2.25rem - 1.25rem - 1rem);
  }
`;
const ReceiptTypeWrap = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  button {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.25rem;
    font-size: 1rem;
    font-family: var(--font-nanumSquare-acR);
    font-weight: 600;
    padding: 0.25rem;
    border-bottom: 2px solid transparent;
  }
  .note-count {
    padding: 0.25rem 0.5rem;
    border-radius: 50%;
    // 기본색상
    color: ${({theme}) => theme.newTheme.default.primary};
    background-color: ${({theme}) => theme.newTheme.default.secondary};
  }
  .active {
    // active 색상
    color: ${({theme}) => theme.newTheme.text.mainText};
    border-bottom: 2px solid ${({theme}) => theme.newTheme.text.mainText};
    .note-count {
      color: ${({theme}) => theme.newTheme.text.btnText_w};
      background-color: ${({theme}) => theme.newTheme.default.primary};
    }
  }
`;
const ReceiptOneWrap = styled.div`
  height: calc(100% - 2.5rem);
  display: flex;
  gap: 1rem;
  overflow-x: auto;
  .list-table {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    text-align: center;
    flex-glow: 1;
  }
  .list-table-header {
    position: sticky;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: ${({theme}) => theme.newTheme.table.tableHeadBg};
    color: ${({theme}) => theme.newTheme.table.tableHeadText};
    border-radius: 0.5rem;
    z-index: 1;
    > div {
      padding: 0.5rem 1rem;
      font-size: 1rem;
    }
  }
`;
const ReceiptOne = styled.div`
  min-height: 3.75rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${({theme}) => theme.newTheme.border.primaryBd};
  > div {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 1rem;
    &:nth-of-type(6) {
      word-break: auto-phrase;
    }
  }
  .thumbnail-wrap {
    max-height: 5rem;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  &:hover {
    background-color: ${({theme}) => theme.newTheme.table.tableBodyHoverBg};
  }
`;

const PaymentOne = styled.div`
  min-height: 3.75rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${({theme}) => theme.newTheme.border.primaryBd};
  > div {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.25rem 0.5rem;
    padding: 0.5rem 1rem;
    border-left: 1px solid ${({ theme }) => theme.newTheme.border.primaryBd};
    &:first-of-type {
      border-left: none;
    }
    &:nth-of-type(6) {
      word-break: auto-phrase;
    }
  }
  &:hover {
    background-color: ${({theme}) => theme.newTheme.table.tableBodyHoverBg};
  }
`;

const NODATATEXT = [{ index: 1, text: "아직 등록된 항목이 없어요." }];

const months = MONTHS;
// 수납이력
export function ReceiptPaymentList() {

  const holidayList = useRecoilValue(holidayState);

  const [loading, setLoading] = useState(false);
  const [receiptSuccess, setReceiptSuccess] = useState(false);
  // select-option용
  const [paymentType, setPaymentType] = useState<provinceInfo[]>(formattedSelectOption(PaymentDetailType));
  const [classList, setClassList] = useState<provinceInfo[]>([
    { label: "전체", value: 0 },
  ]);
  const [studentAll, setStudentAll] = useState<StudentInfo[]>([]);
  const [studentList, setStudentList] = useState<provinceInfo[]>([
    { label: "전체", value: 0 },
  ]);

  const [type, setType] = useState('create');
  // **************************** 페이지 관련 시작
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1); // 현재 페이지
  const [limit, setLimit] = useState(10); // 보여줄 게시물 개수
  const buttonPerPage = 10; // 보여줄 페이지네이션 버튼 수
  // console.log(totalCount, limit);
  const numPages = Math.ceil(totalCount / limit); // 총 페이지 수
  const [startButtonNum, setStartButtonNum] = useState(1); // 버튼 시작 숫자
  const [endButtonNum, setEndButtonNum] = useState(
    startButtonNum + buttonPerPage - 1
  ); // 버튼 끝 숫자

  // Pagenation에서 버튼 클릭 시 전달받는 값
  function isClickButton(str: string) {
    if (str === "prev") handlePrevPage();
    else handleNextPage();
  }
  // 이전페이지 이동(buttonPerPage만큼 -)
  function handlePrevPage() {
    let prevPer =
      page % 10 === 0
        ? page - buttonPerPage
        : page - buttonPerPage + (buttonPerPage - (page % 10));
    setEndButtonNum(prevPer);
    let startPrevPer = prevPer - buttonPerPage + 1;
    setPage(prevPer);
    setStartButtonNum(startPrevPer < 1 ? 1 : startPrevPer); // 처음페이지 버튼의 숫자가 1보다 작을 경우
  }
  // 다음페이지 이동(buttonPerPage만큼 +)
  function handleNextPage() {
    let nextPer =
      page % 10 === 0
        ? page + 1
        : page + 1 + buttonPerPage - ((page % 10) % buttonPerPage);
    setPage(nextPer);
    setStartButtonNum(nextPer);
    let endNextPer = nextPer + buttonPerPage - 1;
    setEndButtonNum(endNextPer > numPages ? numPages : endNextPer); // 마지막페이지 버튼이 총 페이지보다 클 경우
  }
  // **************************** 페이지 관련 끝
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([null, null]);
  const [startDate, endDate] = dateRange;
  const defaultSearchData: {
    payment_type: null | number,
    class_id: number,
    student_id: number[],
    search_date: [Date | null, Date | null]
  } = {
    payment_type: null, // 수납유형 (1:원비, 2:준비물, 3:기타)
    class_id: 0,
    student_id: [0],
    search_date: dateRange,
  }
  const [searchData, setSearchData] = useState(defaultSearchData);
  
  const [paymentList, setPaymentList] = useState<PaymentInfo[]>([]);
  const [discountList, setDiscountList] = useState<DiscountInfo[]>([]);
  const [receiptList, setReceiptList] = useState<ReceiptTotalInfo[]>([]); // 결제 내역(청구서) 전체
  // 결제 상태 선택 - 전체(null)/미납(3)/수납대기(0)/수납완료(2)/취소/환불(4)
  // null(전체)/수납대기(0)/수납요청(1)/수납완료(2)/미납(3)/취소요청(4)/취소완료(5)/환불완료(6)
  const [activeMenu, setActiveMenu] = useState<null|number>(null);
  const [receiptByTypeList, setReceiptByTypeList] = useState<ReceiptTotalInfo[]>([]); // activeMenu에 따른 list
  const [statusCount, setStatusCount] = useState({
    status0: 0, status2: 0, status3: 0, status4: 0,
  });
  const defaultReceiptTotalObj: ReceiptTotalInfo = {
    id: 0,
    site_id: 0,
    student_id: 0,
    student_name: "",
    user_id: 0,
    user_name: "",
    payment_info_id: 0,
    payment_info: undefined,
    discount_info_id: null,
    discount_info: undefined,
    pay_price: 0,
    pay_date: "",
    pay_method: null,
    on_site_payment: null,
    bill_date: "",
    close_date: "",
    cancel_date: "",
    reg_date: "",
    approval_number: "",
    send_status: 0,
    status: 0,
    etc: "",
  }
  const [receiptOne, setReceiptOne] = useState<ReceiptTotalInfo>(defaultReceiptTotalObj);
  const [isOpen, setIsOpen] = useState(false);

  // ****************************
  // 필터 검색
  function handleChangeOption(prop: number, prop_type: string) {
    if (prop_type === 'class') {
      const classStudents = studentAll.filter(s => s.class_list.some(c => c.id === prop));
      const students = formattedSelectOption(classStudents.map((d: any) => ({label: aesCBCDecrypt(d.name), value: d.id})));
      setStudentList(students);
      setSearchData((prev) => ({ ...prev, class_id: prop }));
    }
    // 전체인 경우 student_id 전체 [] - 조회 누를 때
    else if (prop_type === 'student') setSearchData((prev) => ({ ...prev, student_id: [prop] }));
    else setSearchData((prev) => ({ ...prev, payment_type: prop }));
  }
  // 필터 검색 - title 검색
  function handleSearchReceipt() {
    // console.log("수납이력 조회");
    // if (searchData.class_id === 0 && searchData.title === "")
    //   getNoticeDataAPI();
    // else getNoticeDataAPI(searchData);
  }
  const handleJoinType = (menuType: null | number) => {
    setActiveMenu(menuType);
    if (menuType === null) setReceiptByTypeList(receiptList);
    else {
      const typeList = receiptList.filter(receipt => receipt.status === menuType);
      setReceiptByTypeList(typeList);
      // console.log("typeList ", typeList);
    }
  };
  // 청구서 클릭(수정 및 결제)
  const updateReceipt = (index: number) => {
    setType('edit');
    setReceiptOne(receiptList[index]);
    setIsOpen(true);
  }
  // 청구서 모달
  const openReceiptModal = (index: number) => {
    if (type === 'create') setReceiptOne(defaultReceiptTotalObj);
    else setReceiptOne(receiptList[index]);
    setIsOpen(true);
  }
  function closeReceiptModal(prop: boolean) {
    setIsOpen(prop);
  }
  const mainApi = useCallback(async () => {
    setLoading(true);

    // 이용인/사용자/ 정보 가져오기
    const promiseRes = await Promise.allSettled([
      getClass(),
      getPayments(),
      getDiscounts(),
      getStudent(),
    ]);
    const setters = [setClassList, setPaymentList, setDiscountList];
    promiseRes.forEach((result: any, index: number) => {
      const check = checkPromiseOfServer(result);
      if (check === 'S') {
        if (index === 0) {
          const classArray = formattedSelectOption(result.value.data.map((d: any) => ({ label: d.name, value: d.id })));
          setters[index](classArray);
        }
        else if (index === 1) {
          // 수납 - 비활성화 제외(0: 활성화, 1: 비활성화)
          const paymentArray = result.value.data.filter((a: PaymentInfo) => a.is_disabled === 0);
          setters[index](paymentArray);
        }
        else if (index === 2) {
          // 할인/프로모션 - 기간만료 제외
          const discountArray = result.value.data.filter((a: DiscountInfo) => a.end_date < getCurrentDateTime());
          setters[index](discountArray);
        }
        else {
          setStudentAll(result.value.data);
        }
      }
      else if (check === 'F')
        throw new Error("API Error", result.value.message);
      else throw new Error(`Error in Promise ${index}:`, result.value.message);
    });
    
    const receiptRes = await getAllReceipt();
    if (receiptRes.code !== 200) {
      setReceiptList([]);
      setReceiptByTypeList([]);
      throw new Error("receiptRes Error", receiptRes.message);
    }
    else {
      setReceiptList(receiptRes.data);
      // console.log('전체', receiptRes.data);
      setReceiptByTypeList(receiptRes.data);
      // 결제상태별 count나누기
      let status0 = 0; // 결제대기
      let status2 = 0; // 결제완료
      let status3 = 0; // 미납
      let status4 = 0; // 취소/환불
      if (!receiptRes.data.length) return;
      receiptRes.data.forEach((data: ReceiptTotalInfo) => {
        if (data.status === 0) status0++;
        else if (data.status === 2) status2++;
        else if (data.status === 3) status3++;
        else if (data.status > 3) status4++;
      });
      setStatusCount({ status0, status2, status3, status4 });
    }
    setTotalCount(receiptRes.total_count);
    setLoading(false);
  }, []);
  // ****************************
  // useEffect(() => {
  //   mainApi()
  //     .then((result) => {
  //       setLoading(false);
  //     })
  //   .catch((error) => console.error("mainAPi Error ", error));
  // }, []);
  // 기본 수납/할인,프로모션 항목 가져오기 ---------------
  useEffect(() => {
    mainApi();
  }, [mainApi, receiptSuccess]);
  useEffect(() => {
    // console.log("type ", type);
  }, [type]);

  return (
    <>
      <PageHeaderTitleButtonStyle>
        <p className="header-title">수납 이력</p>
        <div className="button-wrap">
          <SolidPrimaryBtn
            className="default-btn"
            onClick={() => openReceiptModal(0)}
          >
            청구서 작성
          </SolidPrimaryBtn>
        </div>
      </PageHeaderTitleButtonStyle>
      <PageArticleWrap>
        <nav className="filter-container">
          <div className="filter-wrap">
            <label>구분</label>
            <SelectOption
              optionData={paymentType}
              onChange={(prop: number) => handleChangeOption(prop, 'type')}
            />
          </div>
          <div className="filter-wrap">
            <label>반</label>
            <SelectOption
              optionData={classList}
              onChange={(prop: number) => handleChangeOption(prop, 'class')}
            />
          </div>
          <div className="filter-wrap">
            <label>학생</label>
            <SelectOption
              optionData={studentList}
              onChange={(prop: number) => handleChangeOption(prop, 'student')}
            />
          </div>
          <CustomDatePickerWrap className="custom-date-picker modal-datepicker">
            <label>날짜</label>
            <ReactDatePicker
              enableTabLoop={false}
              dateFormat="yyyy-MM-dd (E)" // 날짜형태
              placeholderText="이벤트 기간 선택"
              formatWeekDay={(day) => day.substring(0, 1)}
              shouldCloseOnSelect // 날짜 선택 시 datepicker 자동 닫힘
              selectsRange={true}
              startDate={startDate}
              endDate={endDate}
              onChange={(update) => {setDateRange(update)}}
              dropdownMode="select"
              minDate={subYears(new Date(), 1)}
              // dayClassName={(d) => getDayClassName(d, startDate, holidayList)}
              renderCustomHeader={({
                date,
                changeMonth,
                decreaseMonth,
                increaseMonth,
                prevMonthButtonDisabled,
                nextMonthButtonDisabled,
              }) => (
                <div className="custom-header-container">
                  <div>
                    <button
                      type="button"
                      onClick={decreaseMonth}
                      className="custom-month-button"
                      disabled={prevMonthButtonDisabled}
                    >
                      <img src="/image/icon/arrow_left.svg" alt="left" />
                    </button>
                    <span className="custom-year">{getYear(date)}</span>
                    <select
                      value={months[getMonth(date)]}
                      className="custom-month"
                      onChange={({ target: { value } }) =>
                        changeMonth(months.indexOf(value))
                      }
                    >
                      {months.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                    <button
                      type="button"
                      onClick={increaseMonth}
                      className="custom-month-button"
                      disabled={nextMonthButtonDisabled}
                    >
                      <img src="/image/icon/arrow_right.svg" alt="right" />
                    </button>
                  </div>
                </div>
              )}
            />
          </CustomDatePickerWrap>
          <SolidPrimarySubBtn className="default-btn" onClick={handleSearchReceipt}>
            조회
          </SolidPrimarySubBtn>
        </nav>
        {loading ? <Loading /> : (
          <Article>
            <div className="article-header">
              <p>
                <span className="article-header-title">수납 목록({totalCount})</span>
              </p>
            </div>
            <div className="join-wrap">
              <ReceiptTypeWrap>
                <button
                  type="button"
                  className={`text-btn ${
                    activeMenu === null ? "active" : ""
                  }`}
                  onClick={() => handleJoinType(null)}
                >
                  <p>전체</p>
                  <p className="note-count">{totalCount}</p>
                </button>
                <button
                  type="button"
                  className={`text-btn ${
                    activeMenu === 3 ? "active" : ""
                  }`}
                  onClick={() => handleJoinType(3)}
                >
                  <p>미납</p>
                  <p className="note-count">{statusCount.status3}</p>
                </button>
                <button
                  type="button"
                  className={`text-btn ${
                    activeMenu === 0 ? "active" : ""
                  }`}
                  onClick={() => handleJoinType(0)}
                >
                  <p>수납대기</p>
                  <p className="note-count">{statusCount.status0}</p>
                </button>
                <button
                  type="button"
                  className={`text-btn ${
                    activeMenu === 2 ? "active" : ""
                  }`}
                  onClick={() => handleJoinType(2)}
                >
                  <p>수납완료</p>
                  <p className="note-count">{statusCount.status2}</p>
                </button>
                <button
                  type="button"
                  className={`text-btn ${
                    activeMenu === 4 ? "active" : ""
                  }`}
                  onClick={() => handleJoinType(4)}
                >
                  <p>취소/환불</p>
                  <p className="note-count">{statusCount.status4}</p>
                </button>
              </ReceiptTypeWrap>
              <ReceiptOneWrap>
                {totalCount === 0
                  || (activeMenu === 0 && totalCount === 0) || (activeMenu === 2 && totalCount === 0)
                  || (activeMenu === 2 && totalCount === 0) || (activeMenu === 3 && totalCount === 0)
                  ? <NoDataWithImageText text={NODATATEXT} /> : (
                  <div className="list-table">
                    <nav className="list-table-header">
                      <div className="w-15">납기 만료일</div>
                      <div className="w-10">반 이름</div>
                      <div className="w-12">원생 이름</div>
                      <div className="w-12">수납 항목</div>
                      <div className="w-12">수납 금액</div>
                      <div className="w-10">할인 적용</div>
                      <div className="w-10">수납 상태</div>
                      <div className="w-15"></div>
                    </nav>
                    {receiptByTypeList
                      .map((receipt, index) => (
                        <ReceiptOne
                          key={index}
                          onClick={() => updateReceipt(index)}
                        >
                          <div className="w-15">
                            <p>{receipt.close_date}</p>
                          </div>
                          <div className="w-10">
                            {(() => {
                              let classNameArr: ClassInfo[] = [];
                              if(receipt.student_id)
                                classNameArr = studentAll.find(student => student.id === receipt.student_id)?.class_list || [];
                              const className = classNameArr.filter((arr: any) => arr.site_id === SITEID).map(c => c.name);
                              return (
                                <p>{className || ""}</p>
                              );
                            })()}
                          </div>
                          <div className="w-12">
                            <p>{aesCBCDecrypt(receipt.student_name)}</p>
                          </div>
                          <div className="w-12">
                            <p>{PaymentDetailType.find(type => receipt.payment_info_id === type.value)?.label}</p>
                          </div>
                          <div className="w-12">
                            <p>{formatCurrency(receipt.pay_price)}</p>
                          </div>
                          <div className="w-10">
                            <p>{receipt.discount_info ?
                              (receipt.discount_info.discount_type === 1 ? `${receipt.discount_info.rate}%` : `${formatCurrency(receipt.discount_info.price)}원`) : '없음'}</p>
                          </div>
                          <div className="w-10">
                            <p>{PayStatusType.find(s => s.value === receipt.status)?.label}</p>
                          </div>
                          <div className="w-15">
                            <OutlinePrimaryBtn
                              type="button"
                              className="default-btn"
                              // onClick={() => goNotebookEdit(receipt.id)}
                              disabled={receipt.status >= 2 && receipt.status !== 3}
                            >
                              {receipt.status === 0 ? "청구서 전송" : "수납완료 처리"}
                            </OutlinePrimaryBtn>
                          </div>
                        </ReceiptOne>
                      ))}
                  </div>
                )}
              </ReceiptOneWrap>
            </div>
          </Article>
        )}
        {totalCount !== 0 && (
          <Pagenation
            totalCount={totalCount}
            total={numPages}
            limit={limit}
            page={page}
            setPage={setPage}
            startButtonNum={startButtonNum}
            setClickButton={isClickButton}
          />
        )}
      </PageArticleWrap>
      {isOpen && 
        <ReceiptModalComponent
          isOpen={isOpen}
          type={type}
          content={receiptOne}
          setReceiptOne={setReceiptOne}
          isClose={closeReceiptModal}
          classList={classList}
          studentList={studentAll}
          classSelectOption={classList}
          paymentType={paymentType}
          paymentList={paymentList}
          discountList={discountList}
          isSuccess={setReceiptSuccess}
        />
      }
    </>
  );
}

// 수납항목관리
export function PaymentType() {
  const [loading, setLoading] = useState(false);
  const { selectSiteId } = useLoginUserInfo();
  // 수납정보
  const [paymentList, setPaymentList] = useState<PaymentInfo[]>([]);
  const [discountList, setDiscountList] = useState<DiscountInfo[]>([]);
  const [paymentTotalCount, setPaymentTotalCount] = useState(0);
  const [discountTotalCount, setDiscountTotalCount] = useState(0);
  // 수납 모달
  const [paymentIsOpen, setPaymentIsOpen] = useState(false);
  const [paymentType, setPaymentType] = useState('create');
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const defaultPaymentObj: PaymentInfo = {
    id: 0,
    site_id: selectSiteId,
    name: "",
    type: 0,
    price: 0,
    payment_type: 0,
    discount_status: 0,
    etc: "",
    is_disabled: 0,
    age_group: 0,
  }
  const [paymentOne, setPaymentOne] = useState<PaymentInfo>(defaultPaymentObj);
  // 프로모션 모달
  const [promotionType, setPromotionType] = useState('create');
  const [promotionIsOpen, setPromotionIsOpen] = useState(false);
  const [promotionSuccess, setPromotionSuccess] = useState(false);
  const defaultPromotionObj: DiscountInfo = {
    id: 0,
    site_id: selectSiteId,
    name: "",
    rate: 0,
    price: 0,
    discount_type: 1,
    max_price: 0,
    start_date: "",
    end_date: "",
    etc: "",
  }
  const [promotionOne, setPromotionOne] = useState<DiscountInfo>(defaultPromotionObj);
  // 수납이력(청구서 등록)
  const [receiptAll, setReceiptAll] = useState<ReceiptInfo[]>([]);
  // **************** API
  // 수납정보 data 가져오기----------------
  const apiGetPaymentInfoDatas = useCallback(async () => {
    try {
      setLoading(true);
      const paymentInfos = await getPayments();
      if (paymentInfos.code === 200) {
        paymentInfos.data.sort((a: PaymentInfo, b: PaymentInfo) => a.is_disabled - b.is_disabled);
        setPaymentList(paymentInfos.data);
      }
      else {
        setPaymentList([]);
        throw new Error("getPayments Error", paymentInfos.message);
      }
      const discountInfos = await getDiscounts();
      if (discountInfos.code === 200) setDiscountList(discountInfos.data);
      else setDiscountList([]);
      // console.log("paymentInfos ", paymentInfos.data);
      // console.log("discountInfos ", discountInfos.data);
      setPaymentTotalCount(paymentInfos.total_count || 0);
      setDiscountTotalCount(discountInfos.total_count || 0);
      setPaymentSuccess(false);

      const receiptRes = await getAllReceipt();
      if (receiptRes.code === 200) setReceiptAll(receiptRes.data);
      else {
        setReceiptAll([]);
        throw new Error("getAllReceipt Error", receiptRes.message);
      }
    } catch (error) {
      console.error(error);
    }
    finally {
      setLoading(false);
    }
  }, []);
  // **************** API
  // **************** Modal
  // 기본수납 모달 open / close
  const openPaymentModal = (type: string, index: number) => {
    setPaymentType(type);
    if (type === 'create') setPaymentOne(defaultPaymentObj);
    else setPaymentOne(paymentList[index]);
    setPaymentIsOpen(true);
  }
  function closePaymentModal(prop: boolean) {
    setPaymentIsOpen(prop);
  }
  // 프로모션 모달 open/close
  const openPromotionModal = (type: string, index: number) => {
    setPromotionType(type);
    if (type === 'create') setPromotionOne(defaultPromotionObj);
    else setPromotionOne(discountList[index]);
    setPromotionIsOpen(true);
  }
  function closePromotionModal(prop: boolean) {
    setPromotionIsOpen(prop);
  }
  // **************** Modal
  // 수납 정보 수정 ----------------
  // 기본 수납 수정
  function goPaymentEdit(id: number) {
    // console.log("기본 수납 수정 ", id);
  }
  // 할인/프로모션 수정

  // 기본 수납/할인,프로모션 항목 가져오기 ---------------
  useEffect(() => {
    apiGetPaymentInfoDatas();
  }, [apiGetPaymentInfoDatas, paymentSuccess, promotionSuccess]);
  return (
    <>
      {loading ? <Loading /> : 
        (
          <>
          <PageHeaderTitleButtonStyle>
            <p className="header-title">수납항목 관리</p>
          </PageHeaderTitleButtonStyle>
          <PageArticleWrap>
            <article className="list-content-container">
              <div className="article-header height-auto">
                <p>
                  <span className="article-header-title">기본 수납({paymentTotalCount})</span>
                  <TooltipIcon content="이미 청구서에 작성된 수납 및 할인/프로모션은 수정이 불가합니다." />
                </p>
                <div className="button-wrap">
                  <SolidPrimaryBtn
                    className="default-btn"
                    onClick={() => openPaymentModal("create", 0)}
                  >
                    항목 등록
                  </SolidPrimaryBtn>
                </div>
              </div>
              <TwoListContentWrap>
                <div className="list-wrap">
                  {paymentTotalCount === 0 ? (
                    <NoDataWithImageText text={NODATATEXT} />
                  ) : (
                    <>
                      <div className="list-table">
                        <nav className="list-table-header">
                          <div className="w-10">수납 종류</div>
                          <div className="w-30">수납명</div>
                          <div className="w-10">금액</div>
                          <div className="w-10">수납 구분</div>
                          <div className="w-10">할인 가능</div>
                          <div className="w-20">비고</div>
                          <div className="w-10">-</div>
                        </nav>
                        {paymentList.map((payment, index) => (
                          <PaymentOne>
                            <div className="w-10">
                              <p>{PaymentDetailType.find(type => type.value === payment.type)?.label}</p>
                            </div>
                            <div className="w-30">
                              { payment.is_disabled ? <RoundIcon text="미사용" type="disabled" /> : null}
                              <p>{payment.name}</p>
                            </div>
                            <div className="w-10">
                              <p>{formatCurrency(payment.price)}</p>
                            </div>
                            <div className="w-10">
                              <p>{changeReceiptPaymentType(payment.payment_type)}</p>
                            </div>
                            <div className="w-10">
                              <p>{payment.discount_status === 1 ? <AlphabetO /> : <AlphabetX />}</p>
                            </div>
                            <div className="w-20">
                              <p>{payment.etc}</p>
                            </div>
                            <div className="w-10">
                              <OutlinePrimaryBtn
                                type="button"
                                className="default-btn"
                                onClick={() => openPaymentModal("edit", index)}
                                disabled={receiptAll.filter(receipt => receipt.payment_info_id === payment.id).length !== 0}
                              >
                                수정하기
                              </OutlinePrimaryBtn>
                            </div>
                          </PaymentOne>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              </TwoListContentWrap>
            </article>
            <article className="list-content-container">
              <div className="article-header height-auto">
                <p>
                  <span className="article-header-title">할인/프로모션({discountTotalCount})</span>
                  <TooltipIcon content="이미 청구서에 작성된 수납 및 할인/프로모션은 수정이 불가합니다." />
                </p>
                <div className="button-wrap">
                  <SolidPrimaryBtn
                    className="default-btn"
                    onClick={() => openPromotionModal("create", 0)}
                  >
                    항목 등록
                  </SolidPrimaryBtn>
                </div>
              </div>
              <ListContentWrap>
                <div className="list-one-wrap" style={{flexDirection: 'column', gap: 0, height: 'auto'}}>
                  {discountTotalCount === 0 ? (
                    <NoDataWithImageText text={NODATATEXT} />
                  ) : (
                      <>
                      <div className="list-table">
                        <nav className="list-table-header">
                          <div className="w-15">할인/프로모션 내용</div>
                          <div className="w-30">기간</div>
                          <div className="w-10">할인율</div>
                          <div className="w-10">할인가</div>
                          <div className="w-10">진행</div>
                          <div className="w-15">비고</div>
                          <div className="w-10">-</div>
                        </nav>
                        {discountList.map((discount, index) => {
                          const startDate = new Date(discount.start_date.replace(' ', 'T')).getTime();
                          const endDate = new Date(discount.end_date.replace(' ', 'T')).getTime();
                          const rangeDate = Math.floor((endDate - startDate) / (1000 * 3600 * 24));
                          // 0: 진행 전, 1: 진행 중, 2: 진행 종료
                          const isExpired = (new Date().getTime() < startDate) ? 0 : (new Date().getTime() > endDate) ? 2 : 1;
                          return (
                            <PaymentOne>
                              <div className="w-15">
                                <p>{discount.name}</p>
                              </div>
                              <div className="w-30" style={{justifyContent: 'flex-start'}}>
                                <RoundIcon type={isExpired === 2 ? "disabled" : "primary"} text={`${rangeDate}일`} />
                                <p>
                                  {discount.start_date} ~ {discount.end_date}
                                </p>
                              </div>
                              <div className="w-10">
                                <p>{discount.rate}%</p>
                              </div>
                              <div className="w-10">
                                <p>{formatCurrency(discount.price)}원</p>
                              </div>
                              <div className="w-10">
                                <p><RoundIcon type={isExpired === 0 ? "" : isExpired === 1 ? "primary" : "disabled"}
                                  text={isExpired === 0 ? "진행 전" : isExpired === 1 ? "진행 중" : "진행 종료"} /></p>
                              </div>
                              <div className="w-15">
                                <p>{discount.etc}</p>
                              </div>
                              <div className="w-10">
                                <OutlinePrimaryBtn
                                  type="button"
                                  className="default-btn"
                                  onClick={() => openPromotionModal("edit", index)}
                                  disabled={receiptAll.filter(receipt => receipt.discount_info_id === discount.id).length !== 0}
                                >
                                  수정하기
                                </OutlinePrimaryBtn>
                              </div>
                            </PaymentOne>
                          )
                        })}
                      </div>
                    </>
                  )}
                </div>
              </ListContentWrap>
            </article>
          </PageArticleWrap>
          {paymentIsOpen && 
            <PaymentModalComponent
              isOpen={paymentIsOpen}
              type={paymentType}
              content={paymentOne}
              setPaymentOne={setPaymentOne}
              isClose={closePaymentModal}
              isSuccess={setPaymentSuccess}
            />
            }
          {promotionIsOpen && 
            <PromotionModalComponent
              isOpen={promotionIsOpen}
              type={promotionType}
              content={promotionOne}
              setPromotionOne={setPromotionOne}
              isClose={closePromotionModal}
              isSuccess={setPromotionSuccess}
            />
          }
        </>
        )
      }
    </>
  );
}
